import { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { ALL_INSTITUTIONS } from '@/platform/institutionChoice';
import { useSession } from '@/platform/session';

/** Top-bar switch between the institutions a staff member works at (admins: all). */
export function InstitutionSwitcher() {
  const { institutions, institution, setInstitution, isAdmin, isStaff } = useSession();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (!isStaff || (!isAdmin && institutions.length < 2)) return null;

  const options = [
    ...institutions.map((i) => ({ id: i.id, name: i.name })),
    ...(isAdmin ? [{ id: ALL_INSTITUTIONS, name: 'Todas as instituições' }] : []),
  ];
  const currentId = institution?.id ?? ALL_INSTITUTIONS;
  const currentName = institution?.name ?? 'Todas as instituições';

  return (
    <>
      <Button
        color="inherit"
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<AccountBalanceRounded />}
        endIcon={<ExpandMoreRounded />}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        aria-label={`Instituição: ${currentName}. Trocar`}
        sx={{
          maxWidth: { xs: 150, sm: 260 },
          '& .label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        }}
      >
        <span className="label">{currentName}</span>
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            selected={option.id === currentId}
            onClick={() => {
              setAnchor(null);
              setInstitution(option.id);
            }}
          >
            <ListItemIcon>
              {option.id === currentId && <CheckRounded fontSize="small" />}
            </ListItemIcon>
            <ListItemText>{option.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
